var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12219",
    "data-name": "Group 12219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.271,
    height: 19.131,
    viewBox: "0 0 23.271 19.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4532",
    "data-name": "Rectangle 4532",
    width: 23.271,
    height: 19.131,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11172",
    "data-name": "Group 11172",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44625",
    "data-name": "Path 44625",
    d: "M3.7,18.29c.136-.15.221-.244.305-.338.765-.866,1.536-1.726,2.29-2.6A1.51,1.51,0,0,1,7.532,14.8c2.579.01,5.159,0,7.738,0a1.266,1.266,0,0,0,1.41-1.419c0-.677,0-1.355,0-2.033,0-.324.164-.516.425-.51s.407.192.408.5c0,.738.008,1.477,0,2.215a2.07,2.07,0,0,1-2.1,2.077q-3.934.01-7.868,0a.783.783,0,0,0-.652.295c-.831.958-1.672,1.906-2.515,2.854a.839.839,0,0,1-1.51-.538c0-.678,0-1.355,0-2.033,0-.444-.129-.572-.573-.574A2.086,2.086,0,0,1,.144,14.29a2.336,2.336,0,0,1-.136-.762Q0,7.821,0,2.114A2.068,2.068,0,0,1,2.119,0Q8.762,0,15.406,0A2.073,2.073,0,0,1,17.513,2.1c.006.521,0,1.042,0,1.564,0,.324-.166.516-.427.51s-.4-.193-.406-.5c0-.512,0-1.025,0-1.537a1.245,1.245,0,0,0-1.3-1.292q-6.618,0-13.236,0A1.246,1.246,0,0,0,.837,2.151q0,5.668,0,11.335A1.256,1.256,0,0,0,2.16,14.811a2.678,2.678,0,0,1,.694.071A1.206,1.206,0,0,1,3.7,16.041c.007.721,0,1.441,0,2.249",
    transform: "translate(-0.001 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44626",
    "data-name": "Path 44626",
    d: "M151.409,28.46a.419.419,0,0,1-.421-.554,4.315,4.315,0,0,1,.2-.452c.432-.956.861-1.913,1.3-2.865a1.4,1.4,0,0,1,.276-.4q4.109-4.068,8.225-8.127c.338-.334.506-.332.847.013q.834.842,1.664,1.687c.307.312.306.5-.012.812-2.359,2.331-4.742,4.638-7.065,7a7.954,7.954,0,0,1-3.062,2.064c-.579.2-1.13.485-1.7.729-.094.041-.194.069-.255.09m.81-1.267a1.218,1.218,0,0,0,.148-.037c.707-.309,1.415-.616,2.12-.931a.886.886,0,0,0,.248-.183q3.163-3.12,6.325-6.241a1.1,1.1,0,0,1,.254-.141l-1.329-1.419c-.058.049-.106.085-.148.126q-3.226,3.186-6.451,6.373a.66.66,0,0,0-.142.184c-.338.741-.672,1.484-1.026,2.268m10.447-9.069-1.276-1.237-.778.8L161.842,19l.824-.878",
    transform: "translate(-140.456 -14.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44627",
    "data-name": "Path 44627",
    d: "M63.2,62.891h4.065a1.3,1.3,0,0,1,.234.006.414.414,0,0,1,0,.821,1.278,1.278,0,0,1-.234.006H59.084a1.271,1.271,0,0,1-.234-.007.414.414,0,0,1,0-.821,1.3,1.3,0,0,1,.234-.006H63.2",
    transform: "translate(-54.418 -58.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44628",
    "data-name": "Path 44628",
    d: "M63.11,92.182H59.071c-.078,0-.157,0-.234,0a.414.414,0,0,1-.01-.827,1.589,1.589,0,0,1,.182,0h8.234a1.2,1.2,0,0,1,.208.005.414.414,0,0,1,.01.821,1.218,1.218,0,0,1-.234.007H63.11",
    transform: "translate(-54.374 -84.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44629",
    "data-name": "Path 44629",
    d: "M61.279,119.819q1.133,0,2.267,0c.33,0,.52.154.522.414s-.19.419-.517.419q-2.293,0-4.586,0c-.33,0-.52-.154-.521-.414s.189-.418.517-.419c.773,0,1.546,0,2.319,0",
    transform: "translate(-54.374 -111.477)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/write_icon.99822faa21880b7a228818f22914bacd.svg";
export { ForwardRef as ReactComponent };